export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_xquant.png",
      alt: "Nome da extensão",
    },
    title: "Opere com a XQUANT",
    text: [
      "Com mais de 5 anos de experiência em robôs e automação, nossos produtos são pensados para superar suas expectativas trazendo disciplina, gestão de risco e diversificação para os trades.",
      "Para nós, você é a prioridade! Não com dúvidas, venha para a XQuant.",
    ],
  },
  features: {
    title: "Por que utilizar os robôs da XQuant?",
    subtitle: "Veja quais as principais vantagens dos robôs da XQuant.",
    data: [
      {
        title: "Velocidade",
        description:
          "Nossos algoritmos realizam milhares de cálculos por segundo e tomam decisões muito mais rápido do que qualquer ser humano.",
      },
      {
        title: "Ganhe tempo",
        description:
          "Escolha suas estratégias e deixe que a plataforma opere por você. Não é necessário acompanhar o mercado o tempo todo.",
      },
      {
        title: "Sem emocional",
        description: "Com estratégias automatizadas, você elimina decisões impulsivas e irracionais nos investimentos.",
      },
      {
        title: "7 dias para testar",
        description: "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        title: "100% automatizado",
        description: "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        title: "Suporte Individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas dos nossos clientes.",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a XQuant.",
  },
  about: {
    title: "Sobre a XQuant",
    subtitle: "A XQuant",
    col1: [
      "Idealizada para se adaptar às constantes mudanças do mercado financeiro, a XQuant nasceu da expertise de um time de profissionais na criação de algoritmos eficazes. Nossa equipe é formada por especialistas dedicados à busca de estratégias equilibradas e responsáveis, garantindo uma abordagem sólida no universo dos trades automatizados. ",
    ],
    col2: [
      "Acreditamos que a busca constante por performance positiva é a chave para o sucesso. Por isso, nossos algoritmos proprietários são constantemente aprimorados, focando em encontrar oportunidades de forma inteligente e adaptável à dinâmica do mercado. Com a XQuant, você conta com tecnologia de ponta para otimizar seus investimentos, sempre com a seriedade e a responsabilidade que o seu patrimônio merece. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da XQuant",
  },
  strategies: {
    title: "Estratégias XQuant",
    heading: "Algoritmos avançados à sua disposição.",
    subtitle: "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
  testimonials: [
    {
      text: "Sou cliente da Xquant desde o inicio de 2024, como muitos, tive logo de inicio resultados surpreendentes e como varios outros, apesar dos avisos, empolguei, aumentei a quantidade e peguei uma fase ruim de mão cheia, porém sempre vi que existiam muitas estrategias vencedoras e com o tempo isso iria falar mais alto. Após isso tive um ótimo período de recuperação, consegui finalmente aumentar as quantidades e até parar de fazer meus próprios day trades pois deixou de fazer sentido tentar ser melhor do que os r",
      author: "Alexandre Monteiro",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
    {
      text: "Utilizo os robôs Xquant desde dezembro de 2023, como trabalho fora em horário comercial foi a solução para rentabilizar com segurança meu capital investido em risco, acumulo um ganho com os robôs da Xquant de mais de 185% liquido, a equipe de suporte sempre esteve a postos quando algum robô precisou ser atualizado para novas métricas e ciclos de mercado, sempre me passou confiança com a preocupação dos desenvolvedores em fazer todo mundo ficar lucrativo no longo prazo o que é raro em desenvolvedores de auto",
      author: "Eduardo Bonemberger ",
      // image_url: "https://avatars.githubusercontent.com/u/97165289",
    },
  ],
};
